var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRightArrow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 12,
    viewBox: "0 0 8 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.03662 6.12905C7.03662 6.34877 6.95501 6.53711 6.77923 6.70033L1.89502 11.4841C1.75691 11.6222 1.58112 11.6975 1.37395 11.6975C0.959612 11.6975 0.626883 11.3711 0.626883 10.9505C0.626883 10.7433 0.714774 10.5612 0.852888 10.4169L5.2537 6.12905L0.852888 1.84124C0.714774 1.69685 0.626883 1.50851 0.626883 1.30762C0.626883 0.886998 0.959612 0.560547 1.37395 0.560547C1.58112 0.560547 1.75691 0.635882 1.89502 0.773996L6.77923 5.55148C6.95501 5.72098 7.03662 5.90932 7.03662 6.12905Z",
    fill: "#434D59"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrow);
export default __webpack_public_path__ + "static/media/right-arrow.6773ba46210577878d3d41e75b902f4f.svg";
export { ForwardRef as ReactComponent };